import { render, staticRenderFns } from "./PromoBlockSlide.vue?vue&type=template&id=7dc6c38d"
import script from "./PromoBlockSlide.vue?vue&type=script&lang=js"
export * from "./PromoBlockSlide.vue?vue&type=script&lang=js"
import style0 from "./PromoBlockSlide.vue?vue&type=style&index=0&id=7dc6c38d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports